module.exports = __webpack_public_path__ + "static/media/financial-skills@3x.342d4f36.png";